import request from '@/plugins/axios'

export function rawQuery(query){
  return request.post('/dbManager',{query})
}